import { render, staticRenderFns } from "./TaxData.vue?vue&type=template&id=2398702f&scoped=true&"
import script from "./TaxData.vue?vue&type=script&lang=js&"
export * from "./TaxData.vue?vue&type=script&lang=js&"
import style0 from "./TaxData.vue?vue&type=style&index=0&id=2398702f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398702f",
  null
  
)

export default component.exports